import { BackgroundAbout } from "../../components/background";
import Header from "../../components/header";
import Spacer from "../../components/spacer";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import Footer from "../../components/footer";
import PagesHeadLine from "../../components/pagesHeadline";

import "./styles.css";

function ValuesBlock({ identifier, fullsize = false }) {
  const { t } = useTranslation();

  return (
    <div className={`values-block-container ${fullsize ? "full-width" : ""}`}>
      <h3>{t(`about.values.items.${identifier}.title`)}</h3>
      <p>{t(`about.values.items.${identifier}.description`)}</p>
    </div>
  );
}

function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <BackgroundAbout />
      <div className="about-page-container">
        <Header />
        <PagesHeadLine content={t("about.header")}></PagesHeadLine>

        <div className="about-content-container">
          <div className="about-content-container-details">
            <div className="about-content-container-details-mission">
              <h2>{parse(t("about.mission.headline"))}</h2>
              <span className="about-mission-separator" />
              <p>{parse(t("about.mission.content"))}</p>
            </div>

            <div className="about-content-container-details-values">
              <h2>{t("about.values.headline")}</h2>

              <div className="values-blocks-container">
                <ValuesBlock identifier="commitment" />
                <ValuesBlock identifier="transparency" />
                <ValuesBlock identifier="democratization" />
                <ValuesBlock identifier="flexibility" />
                <ValuesBlock identifier="smartSolutions" fullsize={true} />
              </div>
            </div>
          </div>
        </div>

        <Spacer space="15" />
        <Footer />
      </div>
    </div>
  );
}

export default AboutPage;
